module.exports = __webpack_public_path__ + "static/littleWomen2s-b51a1bf1d0e9433a6c9d02935d35289e.jpg";